import React, { useState } from "react";
import { Card, Tabs, Tab, Container, Row, Col } from "react-bootstrap";
import DefaultSetting from "./DefaultSetting";
import Flex from "components/common/Flex";
import MobileNotification from "./MobileNotification";
import ReportsNotification from "../../medpass/ReportsNotification";

const DefaultSettingMain = () => {
  const [activeTab, setActiveTab] = useState("advanced");

  return (
    <>
      <Card>
        <Card.Header className="pb-0 pt-4 mb-2">
          <h4 className="mb-1">
            Group Settings
          </h4>
        </Card.Header>
        <Card.Body className="py-0 mb-4">
          <Row>
            <Col lg={4} className="ps-2 ps-lg-3 me-0 ms-auto">
              <Flex alignItems="center" className="mb-2">
                <div className="flex-1">
                  <h6 className="mb-0">User Name: {localStorage.getItem('username')}</h6>
                </div>
              </Flex>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <br></br>
      <Card className="p-3">
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
        >
          {/* <Tab eventKey="general" title="Group Settings">
            <DefaultSetting />
          </Tab> */}
          <Tab eventKey="advanced" title="Mobile Notifications">
            <MobileNotification />
          </Tab>
            {/* <Tab eventKey="report" title="Report">
              <ReportsNotification />
            </Tab> */}
        </Tabs>
      </Card>
    </>
  );
};

export default DefaultSettingMain;
